(function () {
  function initShangqing(section) {
    if (!section || section.dataset.sqInitialized === "true") return;
    section.dataset.sqInitialized = "true";

    var buttons = section.querySelectorAll("[data-lang-btn]");

    function setLanguage(lang) {
      section.dataset.lang = lang;
      buttons.forEach(function (button) {
        button.setAttribute("aria-pressed", String(button.dataset.langBtn === lang));
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        setLanguage(button.dataset.langBtn);
      });
    });

    var observer = "IntersectionObserver" in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("in");
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" })
      : null;

    section.querySelectorAll(".sq-reveal").forEach(function (element) {
      if (observer) observer.observe(element);
      else element.classList.add("in");
    });

  }

  function initAll() {
    document.querySelectorAll("[data-shangqing-section]").forEach(initShangqing);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function (event) {
    initShangqing(event.target.querySelector("[data-shangqing-section]"));
  });
})();
